/**
 * Formate les données d'un ou plusieurs leads auto depuis l'API
 * @param {Array|Object} apiLeads - Un lead ou un tableau de leads depuis l'API
 * @param {Array} managers - Liste des managers pour le mapping des noms
 * @param {Array} LEAD_TASKS - Constantes des tâches
 * @returns {Array|Object} - Lead(s) formaté(s)
 */
import tools from "../../../../helpers/tools";
export const formatLeadAutoData = (apiLeads, managers, LEAD_TASKS) => {
  const resolveName = (id) => {
    const manager = managers.find((m) => m.id === id);
    return tools.getFullNameAbbr(manager) || id;
  };

  const formatSingleLead = (lead) => {
    return {
      ...lead,
      tasks: (lead.tasks || [])
        .map((task) => {
          const taskConstant = LEAD_TASKS.find((t) => t.id === task.nom);
          const createdByManager = managers.find(
            (m) => m.id === task.creeePar
          );
          const updatedByManager = managers.find(
            (m) => m.id === task.modifieePar
          );
          return {
            id: task.id,
            _id: task.id,
            name: taskConstant?.name || task.nom,
            text: task.commentaire || "",
            isDone: task.statut,
            taskId: task.nom,
            ordre: task.ordre,
            createdBy: createdByManager?.fullName || "",
            updatedBy: updatedByManager?.fullName || "",
            createdAt: task.creeeLe,
            updatedAt: task.modifieeLe,
          };
        })
        .sort((a, b) => a.ordre - b.ordre),
      comments: (lead.comments || []).map((comment) => ({
        id: comment.id,
        text: comment.contenu || "",
        createdBy: resolveName(comment.creePar),
        updatedBy: resolveName(comment.modifiePar),
        createdAt: comment.creeLe || comment.modifieLe,
        updatedAt: comment.modifieLe,
        createdById: comment.creePar,
        updatedById: comment.modifiePar,
      })),
    };
  };

  // Si c'est un tableau, on formate chaque lead
  if (Array.isArray(apiLeads)) {
    return apiLeads.map(formatSingleLead);
  }

  // Sinon, on formate un seul lead
  return formatSingleLead(apiLeads);
};
